import { Text, TextSize, Weight } from 'components/typography/text'
import { CoverImage, Image } from 'components/icons'
import styled from 'styled-components'

/**
 * Wraps the input field box
 */
export const InputWrapper = styled.div`
  padding: 15px;
  display: flex;
  flex-flow: column;
  width: 125px;
`

/**
 * styling for the input field (basically stripping default styles)
 */
export const StrippedInput = styled.input`
  appearance: textfield;
  border: none;
  outline: none;
  background: inherit;
  font-size: ${TextSize.p};
  font-weight: ${Weight.SemiBold};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0;
  max-width: 111px;
  color: ${({ theme }) => theme.primaryFontColor};
`

/**
 * Wraps the whole component (the input field, price and dropdown)
 */
export const InputContainer = styled.div<{ open: boolean }>`
  display: flex;
  flex-flow: row nowrap;
  border-radius: 10px 10px ${({ open }) => (open ? 0 : 10)}px 10px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  background-color: ${({ theme }) => theme.widgetBgColor};
  width: fill-available;
  height: 54px;
  margin: 10px 20px 0 20px;
  align-items: center;
  justify-content: space-between;
  max-width: 100%;
`

/**
 * Wraps the price output field
 */
export const PriceWrapper = styled.div`
  color: ${({ theme }) => theme.seashellWhiteToDeepOceanBlue};
  font-size: ${TextSize.small};
  font-weight: ${Weight.SemiBold};
  opacity: ${({ theme }) => (theme.darkMode ? '0.4' : '0.6')};
`

/**
 * Wraps the price output field
 */
export const InputPriceWrapper = styled.div`
  color: ${({ theme }) => theme.primaryFontColor};
  font-size: ${TextSize.small};
  font-weight: ${Weight.SemiBold};
  opacity: ${({ theme }) => (theme.darkMode ? '0.4' : '0.6')};
`

/**
 * Styling for the divider between input and select box
 */
export const Divider = styled.div`
  width: 0;
  height: 33px;
  border-left: 1px solid ${({ theme }) => theme.borderColor};
`

export const CustomIcon = styled(CoverImage)`
  background-size: auto;
  height: 27px;
  width: 27px;
  border-radius: 50%;
`

export const CustomIndexText = styled(Text)`
  margin-left: 10px;
  font-weight: ${Weight.SemiBold};
  font-size: ${TextSize.four};
  color: ${({ theme }) => theme.secondaryFontColor};
`

export const IndexWrapper = styled.div<{ width?: string }>`
  display: flex;
  align-items: center;
  min-width: 91px;
  padding: 0 5px 0 16px;
  transition: width 0.3s ease-in-out;
  overflow-x: hidden;
`

export const LoaderWrapper = styled.div`
  display: flex;
  color: ${({ theme }) => theme.secondaryFontColor};
`

export const DemoCoinIcon = styled(Image)`
  background-size: cover;
  height: 24px;
  width: 24px;
  border-radius: 50%;
`
